export default function /* @ngInject */ stripeCreateToken($q, stripeConfig, stripeLoadSdk, stripeData) {
    return function(source) {
        let deferredResponse = $q.defer();

        stripeData.pending = true;
        stripeData.token = null;

        stripeLoadSdk().then((Stripe) => {
            Stripe.setPublishableKey(stripeConfig.key);
            Stripe.card.createToken(source, handleStripeResponse);
        }).finally(() => stripeData.pending = false);

        function handleStripeResponse(status, response) {
            if (response.error) {
                deferredResponse.reject(response.error);
            } else {
                deferredResponse.resolve(response);
            }
        }

        return deferredResponse;
    };
}



// WEBPACK FOOTER //
// ./stripe/services/stripe-create-token.js